import URI from 'jsuri';
import Q from 'q';
import _ from 'underscore';

import API from 'js/lib/api';

import type {
  PeerPermissionsAndProgresses,
  SubmissionProgresses,
} from 'bundles/peer/types/PeerPermissionsAndProgresses';

const onDemandPeerAssignmentPermissionsApi = API('/api/onDemandPeerAssignmentPermissions.v1', { type: 'rest' });

const onDemandPeerSubmissionProgressesApi = API('/api/onDemandPeerSubmissionProgresses.v1', { type: 'rest' });

const onDemandPeerSubmissionProgresses = 'onDemandPeerSubmissionProgresses.v1';
const onDemandPeerReceivedReviewProgresses = 'onDemandPeerReceivedReviewProgresses.v1';
const onDemandPeerDisplayablePhaseSchedules = 'onDemandPeerDisplayablePhaseSchedules.v1';

const onDemandPeerSubmissionProgressesFields = [
  'latestSubmissionSummary',
  'latestDraftSummary',
  'latestAttemptSummary',
];

const onDemandPeerReceivedReviewProgressesFields = [
  'evaluationIfReady',
  'earliestCompletionTime',
  'reviewCount',
  'defaultReceivedReviewRequiredCount',
];

const onDemandPeerDisplayablePhaseSchedulesFields = ['currentPhase', 'phaseEnds', 'phaseStarts'];

const onDemandPeerAssignmentPermissionsFields = [
  'deleteSubmission',
  'listSubmissions',
  'reviewPeers',
  'viewReviewSchema',
  'anonymousPeerReview',
  `${onDemandPeerSubmissionProgresses}(${onDemandPeerSubmissionProgressesFields.join(',')})`,
  `${onDemandPeerReceivedReviewProgresses}(${onDemandPeerReceivedReviewProgressesFields.join(',')})`,
  `${onDemandPeerDisplayablePhaseSchedules}(${onDemandPeerDisplayablePhaseSchedulesFields.join(',')})`,
];

const onDemandPeerAssignmentPermissionsIncludes = ['receivedReviewsProgress', 'submissionProgress', 'phaseSchedule'];

export const getPermissionsAndProgresses = (
  userId: number,
  courseId: string,
  itemId: string
): Q.Promise<PeerPermissionsAndProgresses> => {
  const uri = new URI(`${userId}~${courseId}~${itemId}`)
    .addQueryParam('fields', onDemandPeerAssignmentPermissionsFields.join(','))
    .addQueryParam('includes', onDemandPeerAssignmentPermissionsIncludes.join(','));

  return Q(onDemandPeerAssignmentPermissionsApi.get(uri.toString())).then((response) => {
    return {
      assignmentPermissions: _(response.elements).first(),
      submissionProgresses: _(response.linked[onDemandPeerSubmissionProgresses]).first(),
      receivedReviewProgresses: _(response.linked[onDemandPeerReceivedReviewProgresses]).first(),
      displayablePhaseSchedules: _(response.linked[onDemandPeerDisplayablePhaseSchedules]).first(),
    };
  });
};

type GetPeerSubmissionProgressesInput = {
  userId: number;
  courseId: string;
  itemId: string;
};

export const getPeerSubmissionProgresses = async ({
  userId,
  courseId,
  itemId,
}: GetPeerSubmissionProgressesInput): Promise<SubmissionProgresses> => {
  const uri = new URI(`${userId}~${courseId}~${itemId}`).addQueryParam(
    'fields',
    onDemandPeerSubmissionProgressesFields.join(',')
  );

  const peerSubmissionProgressesResponse = await onDemandPeerSubmissionProgressesApi.get(uri.toString());

  return peerSubmissionProgressesResponse.elements?.[0];
};
